import { useGetHttp } from "../../../../hooks/http/http.hook";
import type { IPagination } from "../../../../types/models/pagination.models.types";
import type { IPost } from "../../../../types/models/post.models.types";

interface IResponse{
    posts: IPost[]
    pagination:IPagination
}

export function useGetPostsHttp() {
    return useGetHttp<IResponse>({
        path: "/brand/posts",
    });
}